<template>
  <div>
    <ListMenuCategory
      class="mt-4"
      v-on:category="$store.state.selectedCategory = $event"
    ></ListMenuCategory>
    <transition-group
      tag="div"
      class="d-flex flex-wrap justify-space-between mt-12 pb-12 card-list"
    >
      <router-link
        v-for="menu in filterdCategories"
        :key="menu.menutitle"
        :to="{
          name: 'menu',
          params: {
            id: menu.menutitle,
            menuImgUrl: menu.imageUrl,
            menuTitle: menu.menutitle,
            menuContents: menu.menucontents,
          },
        }"
        style="text-decoration: none"
      >
        <ListMenuItem
          :menu-img-url="menu.imageUrl"
          :menu-title="
            $store.state.localeEn ? menu.menutitle_en : menu.menutitle
          "
        ></ListMenuItem>
      </router-link>
    </transition-group>
  </div>
</template>

<script>
import ListMenuItem from "@/components/ListMenuItem";
import ListMenuCategory from "@/components/ListMenuCategory";

export default {
  name: "ListMenu",
  components: {
    ListMenuItem,
    ListMenuCategory,
  },
  computed: {
    filterdCategories() {
      return this.$store.state.menus.filter(
        (el) => el.category === this.$store.state.selectedCategory
      );
    },
  },
};
</script>

<style scoped>
.v-enter-active {
  transition: all 0.2s ease;
  transition-delay: 0.2s;
}

.v-leave-active {
  transition: all 0.2s ease;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}

.card-list {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
}

.card-list::after {
  content: "";
  display: block;
  width: 340px;
  height: 0;
}

@media (max-width: 760px) {
  .card-list {
    justify-content: center !important;
  }

  .card-list::after {
    width: 0;
  }
}
</style>
